import { CheckboxFormsy, FuseUtils, SelectFormsy, TextFieldFormsy } from '@fuse';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { AppBar, Button, Dialog, DialogActions, DialogContent, Icon, IconButton, InputAdornment, MenuItem, TextField, Toolbar, Typography } from 'material-ui';
import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';
import Tooltip from 'material-ui/Tooltip';
import { withStyles } from 'material-ui/styles';
import moment from 'moment';
import Loader from "other-components/loader/loader";
import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import ReactTable from "react-table";
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';

const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99
    },
    smaller: {
        width: 30,
        height: 20,
    },
});

let cx_cps = [];
let cx_cps_edit = [];

class customerList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedContactsMenu: null,
            expanded: 'panel1',
            openComposeDialog: false,
            openComposeDialogEdit: false,
            cp_data: [],
            cp_data_edit: cx_cps_edit,
            cx_data: [],
            titles: [],
            cx_types: [],
            canSubmit: true,
            editCustomerState: {
                cx_id: '',
                created_date: '',
                cx_type: '',
                cx_ref: '',
                cx_title: '',
                cx_name: '',
                cx_company_name: '',
                cx_tax: '',
                cx_svat: '',
                cx_postal_address: '',
                cx_postal_address_country: '',
                cx_postal_address_state: '',
                cx_postal_address_city: '',
                cx_postal_address_zipcode: '',
                cx_billing_address: '',
                cx_billing_address_country: '',
                cx_billing_address_state: '',
                cx_billing_address_city: '',
                cx_billing_address_zipcode: '',
                cx_email: '',
                cp_title: '',
                cp_name: '',
                cp_nic_ssn_passport: '',
                cp_mobile: '',
                cp_home: '',
                cp_office: '',
                cp_email: '',
                cx_credit_limit: '',
                cx_credit_period: '',
                cx_previlage_discount: '',
                cx_suspended: false,
                cx_active: false,
                cx_contact_persons: [],
            },
            loading: true,
            countries: [],
            cxPostalCountry: {
                value: "Sri Lanka",
                label: "Sri Lanka"
            },
            cxBillingCountry: {
                value: "Sri Lanka",
                label: "Sri Lanka"
            },
            cpPostalCountry: {
                value: "Sri Lanka",
                label: "Sri Lanka"
            },
            cp_address_country_edit: { value: null, label: null },
            startDate: moment().add(-30, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD')
        };

        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
        this.openNewCustomerDialogEdit = this.openNewCustomerDialogEdit.bind(this);
        this.closeNewCustomerDialogEdit = this.closeNewCustomerDialogEdit.bind(this);
        this.addCustomer = this.addCustomer.bind(this);
        this.editCustomer = this.editCustomer.bind(this);
        this.pushContactPerson = this.pushContactPerson.bind(this);
        this.removeContactPerson = this.removeContactPerson.bind(this);
        this.removeContactPersonEdit = this.removeContactPersonEdit.bind(this);
        this.clearContactPersons = this.clearContactPersons.bind(this);
        this.copyPostalAddress = this.copyPostalAddress.bind(this);
        this.copyPostalAddressEdit = this.copyPostalAddressEdit.bind(this);
        this.getCustomerList = this.getCustomerList.bind(this);
        this.removeCustomer = this.removeCustomer.bind(this);
        this.removeCustomerConfirm = this.removeCustomerConfirm.bind(this);
        this.activateCustomer = this.activateCustomer.bind(this);
        this.activateCustomerConfirm = this.activateCustomerConfirm.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.enableButton = this.enableButton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.changeBackground = this.changeBackground.bind(this);
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
    }

    validateCustomer = (data) => {
        // alert("A");
        if (!this.refs.cx_name.getValue() && !this.refs.cx_company.getValue() && !this.refs.cx_postal_address.getValue() && !this.refs.cx_billing_address.getValue()) {
            // alert("B");
            this.setState({ expanded: 'panel1' });

            // if(!this.refs.cx_name.getValue()){

            //     document.getElementById("cx_name").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }

            // if(!this.refs.cx_company.getValue()){

            //     document.getElementById("cx_company").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }

            // if(!this.refs.cx_postal_address.getValue()){

            //     document.getElementById("cx_postal_address").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }

            // if(!this.refs.cx_billing_address.getValue()){

            //     document.getElementById("cx_billing_address").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }
        }


        if (!this.refs.cx_credit_limit.getValue() && !this.refs.cx_credit_period.getValue() && !this.refs.cx_previlage_discount.getValue()) {
            // alert("D");
            this.setState({ expanded: 'panel3' });

            // if(!this.refs.cx_name.getValue()){

            //     document.getElementById("cx_credit_limit").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }

            // if(!this.refs.cx_company.getValue()){

            //     document.getElementById("cx_credit_period").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }

            // if(!this.refs.cx_postal_address.getValue()){

            //     document.getElementById("cx_previlage_discount").style.backgroundColor = "rgba(242, 33, 33,0.1)";
            // }

        }


    }

    addCustomer = (data) => {


        if (this.state.cp_data.length == 0) {

            this.setState({ expanded: 'panel2' });
            this.props.alert.error('At least, one Contact Person needed');
        }


        else {
            // alert("E");
            this.setState({ loading: true });
            this.setState({ openComposeDialog: false });
            let post = {
                'customer_profile': data,
                'contact_persons': this.state.cp_data,
                'envName': window.env
            }

            // axios.post(`http://localhost:5003/crm/addCustomer`,post)
            axios.post(window.crmServer + `/crm/addCustomer`, post)
                .then(res => {
                    // console.log(res.data);
                    if (res.data.status) {
                        this.getCustomerList();
                        this.setState({ loading: false });
                        this.props.alert.success(res.data.msg);
                    }

                    else {
                        // console.log(res.data);
                        this.getCustomerList();
                        this.setState({ loading: false });
                        this.props.alert.error(res.data.msg);
                    }
                })
        }
    };

    editCustomer = (data) => {

        if (this.state.cp_data_edit.length == 0) {
            this.props.alert.error('At least, one Contact Person needed');
        }

        else {

            this.setState({ loading: true });
            this.setState({ openComposeDialogEdit: false });
            let post = {
                'customer_profile': data,
                'contact_persons': this.state.cp_data_edit,
                'envName': window.env
            }

            // axios.post(`http://localhost:5003/crm/editCustomer`,post)
            axios.post(window.crmServer + `/crm/editCustomer`, post)
                .then(res => {
                    if (res.data.status) {
                        this.getCustomerList();
                        this.setState({ loading: false });
                        this.props.alert.success(res.data.msg);
                    }

                    else {
                        this.getCustomerList();
                        this.setState({ loading: false });
                        this.props.alert.error(res.data.msg);
                    }
                })
        }
    };

    removeCustomerConfirm = (cx_code) => {

        confirmAlert({
            title: 'Confirm to Deactivate',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.removeCustomer(cx_code)
                },
                {
                    label: 'No'
                }
            ]
        })

    };

    removeCustomer = (cx_code) => {
        this.setState({ loading: true });
        let post = {
            'cx_code': cx_code
        }
        // axios.post(`http://localhost:5003/crm/removeCustomer`,post)
        axios.post(window.crmServer + `/crm/removeCustomer`, post)
            .then(res => {
                if (res.data.status) {
                    this.getCustomerList();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getCustomerList();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    };

    activateCustomerConfirm = (cx_code) => {

        confirmAlert({
            title: 'Confirm to Activate',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.activateCustomer(cx_code)
                },
                {
                    label: 'No'
                }
            ]
        })

    };

    activateCustomer = (cx_code) => {
        this.setState({ loading: true });
        let post = {
            'cx_code': cx_code
        }
        // axios.post(`http://localhost:5003/crm/activateCustomer`,post)
        axios.post(window.crmServer + `/crm/activateCustomer`, post)
            .then(res => {
                if (res.data.status) {
                    this.getCustomerList();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getCustomerList();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    };

    getCustomerList() {
        this.setState({ loading: true });
        var customers = [];
        var param = '';
        if (this.state.startDate && this.state.endDate) {
            param = 'startDate=' + this.state.startDate + '&endDate=' + this.state.endDate;
        }

        // axios.get('http://localhost:5003/crm/getCustomer/all')
        axios.get(window.crmServer + '/crm/getCustomer/all' + (param != '' ? '?' + param : ''))
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    if (response.data.result) {
                        for (let i = 0; i < response.data.result.length; i++) {
                            if (response.data.result[i].IS_ACTIVE) {
                                var cxObj = "";
                                if (response.data.result[i].CUSTOMER_PROFILE) {
                                    cxObj = {
                                        cx_type: response.data.result[i].CUSTOMER_PROFILE.cx_type,
                                        cx_ref: response.data.result[i].CUSTOMER_PROFILE.cx_ref,
                                        cx_title: response.data.result[i].CUSTOMER_PROFILE.cx_title,
                                        cx_name: response.data.result[i].CUSTOMER_PROFILE.cx_name,
                                        cx_company_name: response.data.result[i].CUSTOMER_PROFILE.cx_company,
                                        cx_tax: response.data.result[i].CUSTOMER_PROFILE.cx_tax,
                                        cx_svat: response.data.result[i].CUSTOMER_PROFILE.cx_svat,
                                        cx_postal_address: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address,
                                        cx_postal_address_country: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_country,
                                        cx_postal_address_state: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_state,
                                        cx_postal_address_city: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_city,
                                        cx_postal_address_zipcode: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_zipcode,
                                        cx_billing_address: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address,
                                        cx_billing_address_country: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_country,
                                        cx_billing_address_state: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_state,
                                        cx_billing_address_city: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_city,
                                        cx_billing_address_zipcode: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_zipcode,
                                        cx_email: response.data.result[i].CUSTOMER_PROFILE.cx_email,
                                        cp_title: '',
                                        cp_name: '',
                                        cp_nic_ssn_passport: '',
                                        cp_mobile: '',
                                        cp_home: '',
                                        cp_office: '',
                                        cp_email: '',
                                        cx_credit_limit: response.data.result[i].CUSTOMER_PROFILE.cx_credit_limit,
                                        cx_credit_period: response.data.result[i].CUSTOMER_PROFILE.cx_credit_period,
                                        cx_previlage_discount: response.data.result[i].CUSTOMER_PROFILE.cx_previlage_discount,
                                        cx_suspended: response.data.result[i].CUSTOMER_PROFILE.cx_suspended,
                                        cx_active: response.data.result[i].CUSTOMER_PROFILE.cx_active,
                                        cx_status: 'Active',
                                        cx_contact_persons: response.data.result[i].CONTACT_PERSONS
                                    }
                                }
                                if (response.data.result[i]) {
                                    // console.log(response.data.result[i]);
                                    customers.push({
                                        cx_id: response.data.result[i].ID_CUSTOMER_PROFILE,
                                        created_date: response.data.result[i].CREATED_DATE,
                                        cx_code: response.data.result[i].CUSTOMER_CODE_PREFIX + ' ' + response.data.result[i].CUSTOMER_CODE + ' ' + response.data.result[i].CUSTOMER_CODE_SUFFIX,
                                        ...cxObj,
                                        contact_person: (
                                            (response.data.result[i].CONTACT_PERSONS[0] && response.data.result[i].CONTACT_PERSONS[0].title) ? response.data.result[i].CONTACT_PERSONS[0].title : ""
                                        ) + ' ' + (
                                                (response.data.result[i].CONTACT_PERSONS[0] && response.data.result[i].CONTACT_PERSONS[0].name) ? response.data.result[i].CONTACT_PERSONS[0].name : ""
                                            ),
                                        address: response.data.result[i].CONTACT_PERSONS[0] && response.data.result[i].CONTACT_PERSONS[0].address ? response.data.result[i].CONTACT_PERSONS[0] : "",
                                    });


                                }
                                // console.log(customers);
                            }
                            else if (!response.data.result[i].IS_ACTIVE) {
                                customers.push({
                                    cx_id: response.data.result[i].ID_CUSTOMER_PROFILE,
                                    created_date: response.data.result[i].CREATED_DATE,
                                    cx_code: response.data.result[i].CUSTOMER_CODE_PREFIX + ' ' + response.data.result[i].CUSTOMER_CODE + ' ' + response.data.result[i].CUSTOMER_CODE_SUFFIX,
                                    cx_type: response.data.result[i].CUSTOMER_PROFILE.cx_type,
                                    cx_ref: response.data.result[i].CUSTOMER_PROFILE.cx_ref,
                                    cx_title: response.data.result[i].CUSTOMER_PROFILE.cx_title,
                                    cx_name: response.data.result[i].CUSTOMER_PROFILE.cx_name,
                                    contact_person: response.data.result[i].CONTACT_PERSONS[0].title + ' ' + response.data.result[i].CONTACT_PERSONS[0].name,
                                    address: response.data.result[i].CONTACT_PERSONS[0].address,
                                    cx_company_name: response.data.result[i].CUSTOMER_PROFILE.cx_company,
                                    cx_tax: response.data.result[i].CUSTOMER_PROFILE.cx_tax,
                                    cx_svat: response.data.result[i].CUSTOMER_PROFILE.cx_svat,
                                    cx_postal_address: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address,
                                    cx_postal_address_country: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_country,
                                    cx_postal_address_state: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_state,
                                    cx_postal_address_city: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_city,
                                    cx_postal_address_zipcode: response.data.result[i].CUSTOMER_PROFILE.cx_postal_address_zipcode,
                                    cx_billing_address: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address,
                                    cx_billing_address_country: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_country,
                                    cx_billing_address_state: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_state,
                                    cx_billing_address_city: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_city,
                                    cx_billing_address_zipcode: response.data.result[i].CUSTOMER_PROFILE.cx_billing_address_zipcode,
                                    cx_email: response.data.result[i].CUSTOMER_PROFILE.cx_email,
                                    cp_title: '',
                                    cp_name: '',
                                    cp_nic_ssn_passport: '',
                                    cp_mobile: '',
                                    cp_home: '',
                                    cp_office: '',
                                    cp_email: '',
                                    cx_credit_limit: response.data.result[i].CUSTOMER_PROFILE.cx_credit_limit,
                                    cx_credit_period: response.data.result[i].CUSTOMER_PROFILE.cx_credit_period,
                                    cx_previlage_discount: response.data.result[i].CUSTOMER_PROFILE.cx_previlage_discount,
                                    cx_suspended: response.data.result[i].CUSTOMER_PROFILE.cx_suspended,
                                    cx_active: response.data.result[i].CUSTOMER_PROFILE.cx_active,
                                    cx_status: 'Inactive',
                                    cx_contact_persons: response.data.result[i].CONTACT_PERSONS
                                });
                            }
                        }

                        for (let i = 0; i < response.data.length; i++) {

                            if (response.data[i].IS_ACTIVE) {
                                customers.push({
                                    cx_id: response.data[i].ID_CUSTOMER_PROFILE,
                                    created_date: response.data[i].CREATED_DATE,
                                    cx_code: response.data[i].CUSTOMER_CODE_PREFIX + ' ' + response.data[i].CUSTOMER_CODE + ' ' + response.data[i].CUSTOMER_CODE_SUFFIX,
                                    cx_type: response.data[i].CUSTOMER_PROFILE.cx_type,
                                    cx_ref: response.data[i].CUSTOMER_PROFILE.cx_ref,
                                    cx_title: response.data[i].CUSTOMER_PROFILE.cx_title,
                                    cx_name: response.data[i].CUSTOMER_PROFILE.cx_name,
                                    contact_person: response.data[i].CONTACT_PERSONS[0].title + ' ' + response.data[i].CONTACT_PERSONS[0].name,
                                    address: response.data[i].CONTACT_PERSONS[0].address,
                                    cx_company_name: response.data[i].CUSTOMER_PROFILE.cx_company,
                                    cx_tax: response.data[i].CUSTOMER_PROFILE.cx_tax,
                                    cx_svat: response.data[i].CUSTOMER_PROFILE.cx_svat,
                                    cx_postal_address: response.data[i].CUSTOMER_PROFILE.cx_postal_address,
                                    cx_postal_address_country: response.data[i].CUSTOMER_PROFILE.cx_postal_address_country,
                                    cx_postal_address_state: response.data[i].CUSTOMER_PROFILE.cx_postal_address_state,
                                    cx_postal_address_city: response.data[i].CUSTOMER_PROFILE.cx_postal_address_city,
                                    cx_postal_address_zipcode: response.data[i].CUSTOMER_PROFILE.cx_postal_address_zipcode,
                                    cx_billing_address: response.data[i].CUSTOMER_PROFILE.cx_billing_address,
                                    cx_billing_address_country: response.data[i].CUSTOMER_PROFILE.cx_billing_address_country,
                                    cx_billing_address_state: response.data[i].CUSTOMER_PROFILE.cx_billing_address_state,
                                    cx_billing_address_city: response.data[i].CUSTOMER_PROFILE.cx_billing_address_city,
                                    cx_billing_address_zipcode: response.data[i].CUSTOMER_PROFILE.cx_billing_address_zipcode,
                                    cx_email: response.data.result[i].CUSTOMER_PROFILE.cx_email,
                                    cp_title: '',
                                    cp_name: '',
                                    cp_nic_ssn_passport: '',
                                    cp_mobile: '',
                                    cp_home: '',
                                    cp_office: '',
                                    cp_email: '',
                                    cx_credit_limit: response.data[i].CUSTOMER_PROFILE.cx_credit_limit,
                                    cx_credit_period: response.data[i].CUSTOMER_PROFILE.cx_credit_period,
                                    cx_previlage_discount: response.data[i].CUSTOMER_PROFILE.cx_previlage_discount,
                                    cx_suspended: response.data[i].CUSTOMER_PROFILE.cx_suspended,
                                    cx_active: response.data[i].CUSTOMER_PROFILE.cx_active,
                                    cx_status: 'Active',
                                    cx_contact_persons: response.data[i].CONTACT_PERSONS
                                });
                            }
                            else if (!response.data[i].IS_ACTIVE) {
                                customers.push({
                                    cx_id: response.data[i].ID_CUSTOMER_PROFILE,
                                    created_date: response.data[i].CREATED_DATE,
                                    cx_code: response.data[i].CUSTOMER_CODE_PREFIX + ' ' + response.data[i].CUSTOMER_CODE + ' ' + response.data[i].CUSTOMER_CODE_SUFFIX,
                                    cx_type: response.data[i].CUSTOMER_PROFILE.cx_type,
                                    cx_ref: response.data[i].CUSTOMER_PROFILE.cx_ref,
                                    cx_title: response.data[i].CUSTOMER_PROFILE.cx_title,
                                    cx_name: response.data[i].CUSTOMER_PROFILE.cx_name,
                                    contact_person: response.data[i].CONTACT_PERSONS[0].title + ' ' + response.data[i].CONTACT_PERSONS[0].name,
                                    address: response.data[i].CONTACT_PERSONS[0].address,
                                    cx_company_name: response.data[i].CUSTOMER_PROFILE.cx_company,
                                    cx_tax: response.data[i].CUSTOMER_PROFILE.cx_tax,
                                    cx_svat: response.data[i].CUSTOMER_PROFILE.cx_svat,
                                    cx_postal_address: response.data[i].CUSTOMER_PROFILE.cx_postal_address,
                                    cx_postal_address_country: response.data[i].CUSTOMER_PROFILE.cx_postal_address_country,
                                    cx_postal_address_state: response.data[i].CUSTOMER_PROFILE.cx_postal_address_state,
                                    cx_postal_address_city: response.data[i].CUSTOMER_PROFILE.cx_postal_address_city,
                                    cx_postal_address_zipcode: response.data[i].CUSTOMER_PROFILE.cx_postal_address_zipcode,
                                    cx_billing_address: response.data[i].CUSTOMER_PROFILE.cx_billing_address,
                                    cx_billing_address_country: response.data[i].CUSTOMER_PROFILE.cx_billing_address_country,
                                    cx_billing_address_state: response.data[i].CUSTOMER_PROFILE.cx_billing_address_state,
                                    cx_billing_address_city: response.data[i].CUSTOMER_PROFILE.cx_billing_address_city,
                                    cx_billing_address_zipcode: response.data[i].CUSTOMER_PROFILE.cx_billing_address_zipcode,
                                    cx_email: response.data.result[i].CUSTOMER_PROFILE.cx_email,
                                    cp_title: '',
                                    cp_name: '',
                                    cp_nic_ssn_passport: '',
                                    cp_mobile: '',
                                    cp_home: '',
                                    cp_office: '',
                                    cp_email: '',
                                    cx_credit_limit: response.data[i].CUSTOMER_PROFILE.cx_credit_limit,
                                    cx_credit_period: response.data[i].CUSTOMER_PROFILE.cx_credit_period,
                                    cx_previlage_discount: response.data[i].CUSTOMER_PROFILE.cx_previlage_discount,
                                    cx_suspended: response.data[i].CUSTOMER_PROFILE.cx_suspended,
                                    cx_active: response.data[i].CUSTOMER_PROFILE.cx_active,
                                    cx_status: 'Inactive',
                                    cx_contact_persons: response.data[i].CONTACT_PERSONS
                                });
                            }
                        }

                    }
                this.setState({ loading: false });
                this.setState({ cx_data: customers });
                console.log('cx_data', customers);
            });
    }

    openNewCustomerDialog() {
        this.setState({ loading: true });
        this.setState({ expanded: 'panel1' });
        this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        this.setState({ openComposeDialog: false });
    }

    openNewCustomerDialogEdit(data) {
        this.setState({ loading: true });

        var tmpPostal = {
            value: data.cx_postal_address_country,
            label: data.cx_postal_address_country
        }

        var tmpBilling = {
            value: data.cx_billing_address_country,
            label: data.cx_billing_address_country
        }
        this.setState({

            editCustomerState: {
                cx_id: data.cx_id,
                created_date: data.created_date,
                cx_type: data.cx_type,
                cx_ref: data.cx_ref,
                cx_title: data.cx_title,
                cx_name: data.cx_name,
                cx_company_name: data.cx_company_name,
                cx_tax: data.cx_tax,
                cx_svat: data.cx_svat,
                cx_postal_address: data.cx_postal_address,
                cx_postal_address_country: tmpPostal,
                cx_postal_address_state: data.cx_postal_address_state,
                cx_postal_address_city: data.cx_postal_address_city,
                cx_postal_address_zipcode: data.cx_postal_address_zipcode,
                cx_billing_address: data.cx_billing_address,
                cx_billing_address_country: tmpBilling,
                cx_billing_address_state: data.cx_billing_address_state,
                cx_billing_address_city: data.cx_billing_address_city,
                cx_billing_address_zipcode: data.cx_billing_address_zipcode,
                cx_tax: data.cx_tax,
                cx_email: data.cx_email,
                cp_title: '',
                cp_name: '',
                cp_nic_ssn_passport: '',
                cp_address_list: data.cx_contact_persons,
                cp_mobile: '',
                cp_home: '',
                cp_office: '',
                cp_email: '',
                cx_credit_limit: data.cx_credit_limit,
                cx_credit_period: data.cx_credit_period,
                cx_previlage_discount: data.cx_previlage_discount,
                cx_suspended: data.cx_suspended,
                cx_active: data.cx_active,
            }
        });

        cx_cps_edit = [];

        for (let i = 0; i < data.cx_contact_persons.length; i++) {
            cx_cps_edit.push(
                {
                    'name': data.cx_contact_persons[i].name,
                    'nic_ssn_passport': data.cx_contact_persons[i].nic_ssn_passport,
                    'address': data.cx_contact_persons[i].address,
                    'address_country': data.cx_contact_persons[i].address_country,
                    'address_state': data.cx_contact_persons[i].address_state,
                    'address_city': data.cx_contact_persons[i].address_city,
                    'address_zipcode': data.cx_contact_persons[i].address_zipcode,
                    'phone_mobile': data.cx_contact_persons[i].phone_mobile,
                    'phone_home': data.cx_contact_persons[i].phone_home,
                    'phone_office': data.cx_contact_persons[i].phone_office,
                    'fax': data.cx_contact_persons[i].fax,
                    'email': data.cx_contact_persons[i].email,
                }
            );
        }
        this.setState({ cp_data_edit: cx_cps_edit });
        this.setState({ expanded: 'panelEdit1' });
        this.setState({ openComposeDialogEdit: true });
        this.setState({ loading: false });
    }

    closeNewCustomerDialogEdit() {
        this.setState({ openComposeDialogEdit: false });
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    pushContactPerson() {

        if (this.refs.cp_name.getValue() != '' && this.refs.cp_mobile.getValue() != '' && this.refs.cp_name.getValue() != null && this.refs.cp_mobile.getValue() != null) {
            const cp = {
                'title': (this.refs.cp_title) ? this.refs.cp_title.getValue() : "",
                'name': (this.refs.cp_name) ? this.refs.cp_name.getValue() : "",
                'nic_ssn_passport': (this.refs.cp_nic_ssn_passport) ? this.refs.cp_nic_ssn_passport.getValue() : "",
                'address': (this.refs.cp_address) ? this.refs.cp_address.getValue() : "",
                'address_country': (this.refs.cp_address_country) ? this.refs.cp_address_country.getValue() : "",
                'address_state': (this.refs.cp_address_state) ? this.refs.cp_address_state.getValue() : "",
                'address_city': (this.refs.cp_address_city) ? this.refs.cp_address_city.getValue() : "",
                'address_zipcode': (this.refs.cp_address_zipcode) ? this.refs.cp_address_zipcode.getValue() : "",
                'phone_mobile': (this.refs.cp_mobile) ? this.refs.cp_mobile.getValue() : "",
                'phone_home': (this.refs.cp_home) ? this.refs.cp_home.getValue() : "",
                'phone_office': (this.refs.cp_office) ? this.refs.cp_office.getValue() : "",
                'fax': (this.refs.cp_fax) ? this.refs.cp_fax.getValue() : "",
                'email': (this.refs.cp_email) ? this.refs.cp_email.getValue() : "",
            };

            const filteredCp = Object.fromEntries(
                Object.entries(cp).filter(([_, value]) => value !== "")
            );

            cx_cps.push(filteredCp);

            this.setState({ cp_data: cx_cps });

            (this.refs.cp_name) ? this.refs.cp_name.setValue("") : "";
            (this.refs.cp_nic_ssn_passport) ? this.refs.cp_nic_ssn_passport.setValue("") : "";
            (this.refs.cp_address) ? this.refs.cp_address.setValue("") : "";
            // this.refs.cp_address.setValue("");
            (this.refs.cp_address_country) ? this.refs.cp_address_country.setValue("") : "";
            (this.refs.cp_address_state) ? this.refs.cp_address_state.setValue("") : "";
            (this.refs.cp_address_city) ? this.refs.cp_address_city.setValue("") : "";
            (this.refs.cp_address_zipcode) ? this.refs.cp_address_zipcode.setValue("") : "";
            (this.refs.cp_mobile) ? this.refs.cp_mobile.setValue("") : "";
            (this.refs.cp_home) ? this.refs.cp_home.setValue("") : "";
            (this.refs.cp_office) ? this.refs.cp_office.setValue("") : "";
            (this.refs.cp_fax) ? this.refs.cp_fax.setValue("") : "";
            (this.refs.cp_email) ? this.refs.cp_email.setValue("") : "";
        }
    }

    removeContactPersonConfirm = (element) => {
        confirmAlert({
            title: 'Confirm to Remove',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.removeContactPerson(element)
                },
                {
                    label: 'No'
                }
            ]
        })
    };

    removeContactPerson(element) {
        cx_cps = [...this.state.cp_data]; // make a separate copy of the array
        var index = cx_cps.indexOf(element)
        cx_cps.splice(index, 1);
        this.setState({ cp_data: cx_cps });
    }

    clearContactPersons() {
        cx_cps = [];
        this.setState({ cp_data: cx_cps });
    }

    pushContactPersonEdit() {
        // console.log(cx_cps_edit);
        if (this.refs.cp_name_edit.getValue() != '' && this.refs.cp_mobile_edit.getValue() != '') {

            const editedCp = {
                'title': (this.refs.cp_title_edit) ? this.refs.cp_title_edit.getValue() : "",
                'name': (this.refs.cp_name_edit) ? this.refs.cp_name_edit.getValue() : "",
                'nic_ssn_passport': (this.refs.cp_nic_ssn_passport_edit) ? this.refs.cp_nic_ssn_passport_edit.getValue() : "",
                'address': (this.refs.cp_address_edit) ? this.refs.cp_address_edit.getValue() : "",
                'address_country': (this.refs.cp_address_country_edit) ? this.refs.cp_address_country_edit.getValue() : "",
                'address_state': (this.refs.cp_address_state_edit) ? this.refs.cp_address_state_edit.getValue() : "",
                'address_city': (this.refs.cp_address_city_edit) ? this.refs.cp_address_city_edit.getValue() : "",
                'address_zipcode': (this.refs.cp_address_zipcode_edit) ? this.refs.cp_address_zipcode_edit.getValue() : "",
                'phone_mobile': (this.refs.cp_mobile_edit) ? this.refs.cp_mobile_edit.getValue() : "",
                'phone_home': (this.refs.cp_home_edit) ? this.refs.cp_home_edit.getValue() : "",
                'phone_office': (this.refs.cp_office_edit) ? this.refs.cp_office_edit.getValue() : "",
                'fax': (this.refs.cp_fax_edit) ? this.refs.cp_fax_edit.getValue() : "",
                'email': (this.refs.cp_email_edit) ? this.refs.cp_email_edit.getValue() : "",
            };

            // Filter out properties with empty values
            const filteredEditedCp = Object.fromEntries(
                Object.entries(editedCp).filter(([_, value]) => value !== "")
            );

            cx_cps_edit.push(filteredEditedCp);

            this.setState({ cp_data_edit: cx_cps_edit });

            // console.log(cx_cps_edit);

            // this.refs.cp_name_edit.setValue("");
            // this.refs.cp_nic_ssn_passport_edit.setValue("");
            // this.refs.cp_address_edit.setValue("");
            // this.refs.cp_address_edit.setValue("");
            // this.refs.cp_address_country_edit.setValue("");
            // this.refs.cp_address_state_edit.setValue("");
            // this.refs.cp_address_city_edit.setValue("");
            // this.refs.cp_address_zipcode_edit.setValue("");
            // this.refs.cp_mobile_edit.setValue("");
            // this.refs.cp_home_edit.setValue("");
            // this.refs.cp_office_edit.setValue("");
            // this.refs.cp_email_edit.setValue("");

            (this.refs.cp_name) ? this.refs.cp_name.setValue("") : "";
            (this.refs.cp_nic_ssn_passport) ? this.refs.cp_nic_ssn_passport.setValue("") : "";
            (this.refs.cp_address) ? this.refs.cp_address.setValue("") : "";
            // this.refs.cp_address.setValue("");
            (this.refs.cp_address_country) ? this.refs.cp_address_country.setValue("") : "";
            (this.refs.cp_address_state) ? this.refs.cp_address_state.setValue("") : "";
            (this.refs.cp_address_city) ? this.refs.cp_address_city.setValue("") : "";
            (this.refs.cp_address_zipcode) ? this.refs.cp_address_zipcode.setValue("") : "";
            (this.refs.cp_mobile) ? this.refs.cp_mobile.setValue("") : "";
            (this.refs.cp_home) ? this.refs.cp_home.setValue("") : "";
            (this.refs.cp_office) ? this.refs.cp_office.setValue("") : "";
            (this.refs.cp_fax) ? this.refs.cp_fax.setValue("") : "";
            (this.refs.cp_email) ? this.refs.cp_email.setValue("") : "";


        }
    }

    removeContactPersonEditConfirm = (element) => {
        confirmAlert({
            title: 'Confirm to Remove',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.removeContactPersonEdit(element)
                },
                {
                    label: 'No'
                }
            ]
        })
    };

    removeContactPersonEdit(element) {
        cx_cps_edit = [...this.state.cp_data_edit]; // make a separate copy of the array
        var index = cx_cps_edit.indexOf(element)
        cx_cps_edit.splice(index, 1);
        this.setState({ cp_data_edit: cx_cps_edit });
    }

    clearContactPersonsEdit() {
        cx_cps_edit = [];
        this.setState({ cp_data_edit: cx_cps_edit });
    }

    copyPostalAddress() {
        this.refs.cx_billing_address.setValue(this.refs.cx_postal_address.getValue());
        // this.refs.cx_billing_address_country.setValue(this.refs.cx_postal_address_country.getValue());
        this.refs.cx_billing_address_state.setValue(this.refs.cx_postal_address_state.getValue());
        this.refs.cx_billing_address_city.setValue(this.refs.cx_postal_address_city.getValue());
        this.refs.cx_billing_address_zipcode.setValue(this.refs.cx_postal_address_zipcode.getValue());
        var tmp = {
            value: this.refs.cx_postal_address_country.getValue(),
            label: this.refs.cx_postal_address_country.getValue()
        }

        this.setState({ cxBillingCountry: tmp });
    }

    copyPostalAddressEdit() {
        this.refs.cx_billing_address_edit.setValue(this.refs.cx_postal_address_edit.getValue());
        // this.refs.cx_billing_address_country_edit.setValue(this.refs.cx_postal_address_country_edit.getValue());
        this.refs.cx_billing_address_state_edit.setValue(this.refs.cx_postal_address_state_edit.getValue());
        this.refs.cx_billing_address_city_edit.setValue(this.refs.cx_postal_address_city_edit.getValue());
        this.refs.cx_billing_address_zipcode_edit.setValue(this.refs.cx_postal_address_zipcode_edit.getValue());
        var tmp = {
            value: this.refs.cx_postal_address_country_edit.getValue(),
            label: this.refs.cx_postal_address_country_edit.getValue()
        }

        this.setState(prevState => ({ editCustomerState: { ...prevState.editCustomerState, cx_billing_address_country: tmp } }));
    }

    handleChange = panel => (event, expanded) => {

        // this.setState({
        //             expanded: expanded ? panel : false,
        //         });

        if (panel == 'panel2' || panel == 'panel3') {
            if (this.refs.cx_name.getValue() && this.refs.cx_company.getValue() && this.refs.cx_postal_address.getValue() && this.refs.cx_billing_address.getValue()) {
                document.getElementById("cx_name").style.backgroundColor = "";
                document.getElementById("cx_company").style.backgroundColor = "";
                document.getElementById("cx_postal_address").style.backgroundColor = "";
                document.getElementById("cx_billing_address").style.backgroundColor = "";
                this.setState({
                    expanded: expanded ? panel : false,
                });

                if (panel == 'panel2') {
                    document.getElementById("cp_name").focus();
                }

                if (panel == 'panel3') {
                    document.getElementById("cx_credit_limit").focus();
                }

            }

            else {

                this.setState({
                    expanded: 'panel1'
                });

                if (!this.refs.cx_name.getValue()) {

                    document.getElementById("cx_name").style.backgroundColor = "rgba(242, 33, 33,0.1)";
                }

                if (!this.refs.cx_company.getValue()) {

                    document.getElementById("cx_company").style.backgroundColor = "rgba(242, 33, 33,0.1)";
                }

                if (!this.refs.cx_postal_address.getValue()) {

                    document.getElementById("cx_postal_address").style.backgroundColor = "rgba(242, 33, 33,0.1)";
                }

                if (!this.refs.cx_billing_address.getValue()) {

                    document.getElementById("cx_billing_address").style.backgroundColor = "rgba(242, 33, 33,0.1)";
                }
            }
        }
        else {
            this.setState({
                expanded: expanded ? panel : false,
            });
        }

    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    openSelectedContactMenu = (event) => {
        this.setState({ selectedContactsMenu: event.currentTarget });
    };

    closeSelectedContactsMenu = () => {
        this.setState({ selectedContactsMenu: null });
    };

    loadAllCountries() {
        var loadCountryList = [];

        axios.get('https://restcountries.eu/rest/v2/all')
            .then(response => {
                // console.log();
                for (let i = 0; i < response.data.length; i++) {

                    loadCountryList.push({
                        value: response.data[i].name,
                        label: response.data[i].name
                    });
                }

            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
        this.setState({ countries: loadCountryList });
    }

    handlecxPostalCountryChange = (selectedOption) => {

        if (selectedOption) {
            this.setState({ cxPostalCountry: selectedOption });
        }
        else {
            var tmp = {
                value: null,
                label: null
            }

            this.setState({ cxPostalCountry: tmp });
        }
    }

    handlecxBillingCountryChange = (selectedOption) => {

        if (selectedOption) {
            this.setState({ cxBillingCountry: selectedOption });
        }
        else {
            var tmp = {
                value: null,
                label: null
            }

            this.setState({ cxBillingCountry: tmp });
        }

    }

    handlecxPostalCountryChangeEdit = (selectedOption) => {

        if (selectedOption) {
            this.setState(prevState => ({ editCustomerState: { ...prevState.editCustomerState, cx_postal_address_country: selectedOption } }));
        }
        else {
            var tmp = {
                value: null,
                label: null
            }

            this.setState(prevState => ({ editCustomerState: { ...prevState.editCustomerState, cx_postal_address_country: tmp } }));
        }
    }

    handlecxBillingCountryChangeEdit = (selectedOption) => {

        if (selectedOption) {
            this.setState(prevState => ({ editCustomerState: { ...prevState.editCustomerState, cx_billing_address_country: selectedOption } }));
        }
        else {
            var tmp = {
                value: null,
                label: null
            }

            this.setState(prevState => ({ editCustomerState: { ...prevState.editCustomerState, cx_billing_address_country: tmp } }));
        }
    }

    handlecpPostalCountryChange = (selectedOption) => {

        if (selectedOption) {
            this.setState({ cpPostalCountry: selectedOption });
        }
        else {
            var tmp = {
                value: null,
                label: null
            }

            this.setState({ cpPostalCountry: tmp });
        }

    }

    handlecpPostalCountryChangeEdit = (selectedOption) => {

        if (selectedOption) {
            this.setState({ cp_address_country_edit: selectedOption });
        }
        else {
            var tmp = {
                value: null,
                label: null
            }

            this.setState({ cp_address_country_edit: tmp });
        }

    }

    changeBackground = (elenemt) => {

        if (elenemt == "cx_name") {

            this.refs.cx_name.setValue(this.refs.cx_name_tmp.getValue());
            document.getElementById("cx_name").style.backgroundColor = "";
        }
    }

    setStartDate = (startDate) => {
        this.setState({ startDate: startDate });
    }

    setEndDate = (endDate) => {
        this.setState({ endDate: endDate });
    }


    render() {
        const { classes, contacts, searchText } = this.props;
        const data = this.getFilteredArray(contacts, searchText);
        const { expanded } = this.state;
        const { cp_data } = this.state;
        const { cp_data_edit } = this.state;
        const { cx_data } = this.state;
        const { titles } = this.state;
        const { cx_types } = this.state;


        var columns = [
            {
                Header: "Name",
                accessor: "name",
            }
        ];
        if (window.env != "IMC") {
            columns.push({
                Header: "NIC/SSN/Passport",
                accessor: "nic_ssn_passport",
            }, {
                Header: "Address",
                accessor: "address",
            }, {
                Header: "Phone(Mobile)",
                accessor: "phone_mobile",
            }, {
                Header: "Phone(Home)",
                accessor: "phone_home",
            }, {
                Header: "Phone(Office)",
                accessor: "phone_office",
            }, {
                Header: "Fax",
                accessor: "fax",
            }, {
                Header: "Email",
                accessor: "email",
            });
        } else {
            columns.push({
                Header: "Phone(Mobile)",
                accessor: "phone_mobile",
            })
        }

        columns.push({
            Header: "",
            width: 128,
            Cell: row => (
                <div className="flex items-center">
                    <IconButton
                        onClick={(ev) => {
                            this.state.openComposeDialogEdit ?
                                this.removeContactPersonEditConfirm(row.original)
                                :
                                this.removeContactPersonConfirm(row.original);
                        }}
                    >
                        <Icon>delete</Icon>
                    </IconButton>
                </div>
            )
        })


        if (this.state.loading) {
            return (


                <Loader />

            );
        }
        else {

            if (!data && data.length === 0) {
                return (
                    <div className="flex items-center justify-center h-full">
                        <Typography color="textSecondary" variant="headline">
                            There are no customers!
                        </Typography>
                    </div>
                );
            }

            return (
                <React.Fragment>

                    <Toolbar className="flex w-full pt-24 px-12">
                        <h2 className="w-full subtitle-color">
                            Customer Master
                        </h2>
                        <div className="px-12">
                            <Button
                                className="w-160"
                                type="button"
                                variant="raised"
                                color="secondary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    this.removeContactPerson();
                                    this.openNewCustomerDialog();
                                }}
                            >
                                New Customer
                            </Button>
                        </div>
                        <div className="px-12">
                            <Button
                                variant="raised"
                                color="default"
                            >
                                Help
                            </Button>
                        </div>
                    </Toolbar>
                    <Toolbar>
                        <TextField
                            type="date"
                            value={this.state.startDate}
                            name="startDate"
                            label="From Date"
                            required
                            onChange={(ev) => {
                                ev.stopPropagation();
                                this.setStartDate(ev.target.value);
                            }}
                        />
                        <TextField
                            type="date"
                            value={this.state.endDate}
                            name="endDate"
                            label="To Date"
                            required
                            onChange={(ev) => {
                                ev.stopPropagation();
                                this.setEndDate(ev.target.value);
                            }}
                        />
                        <Button
                            type="submit"
                            className="m-4 mt-20 float-right"
                            variant="raised"
                            color="secondary"
                            onClick={(ev) => {
                                ev.stopPropagation();
                                this.getCustomerList();
                            }}
                        >
                            Search
                        </Button>
                    </Toolbar>
                    <ReactTable
                        className={classNames(classes.root, "-striped -highlight m-12 border-2 border-green-darkest customer-list-margin")}
                        getTrProps={() => {
                            return {
                                className: "cursor-pointer",
                            }
                        }}
                        data={Object.entries(this.state.cx_data)}
                        columns={[
                            {
                                width: 100,
                                Header: "Code",
                                accessor: "cx_code",
                                filterable: true,
                                className: 'px-20 mx-20',
                                Cell: row => (
                                    <span>
                                        <span style={{

                                            color: row.original.cx_status == "Active" ? '#57d500' : '#Ff0000',
                                            transition: 'all .3s ease'
                                        }}>
                                            &#x25cf;
                                        </span>
                                        {
                                            row.original[1] ? row.original[1].cx_code : "-"
                                        }
                                    </span>
                                )
                            },
                            {
                                Header: "Customer Name",
                                accessor: "cx_name",
                                filterable: true,
                                Cell: row => (
                                    row.original[1] ? row.original[1].cx_name : ""
                                )
                            },
                            {
                                Header: "Contact Person",
                                accessor: "contact_person",
                                filterable: true,
                                Cell: row => (
                                    row.original[1] ? row.original[1].contact_person : ""
                                )
                            },
                            {
                                Header: "Address",
                                accessor: "address",
                                filterable: true,
                                Cell: row => (
                                    row.original[1] ? Object.entries(row.original[1].address) : ""
                                )
                            },
                            {
                                width: 100,
                                Header: "CR Limit",
                                accessor: "cx_credit_limit",
                                filterable: true,
                                className: "justify-start",
                                Cell: row => (
                                    row.original[1] ? new Intl.NumberFormat().format(row.original[1].cx_credit_limit) : "-"
                                )
                            },
                            {
                                width: 100,
                                Header: "CR Period",
                                accessor: "cx_credit_period",
                                filterable: true,
                                className: "justify-start",
                                Cell: row => (
                                    row.original[1].cx_credit_period ? row.original[1].cx_credit_period + ' Days' : "-"
                                )
                            },
                            // {
                            //     Header: "Status",
                            //     accessor: "cx_status",
                            //     filterable: true,
                            //     className: "justify-center",
                            //     Cell: row => (

                            //         <div className="flex items-center">
                            //             <Icon
                            //                 className={row.value === 'Active' ? 'text-green-light'
                            //                     : row.value === 'Inactive' ? 'text-red-light'
                            //                         : 'text-orange-light'}
                            //                 title={row.value === 'Active' ? 'Active'
                            //                     : row.value === 'Inactive' ? 'Inactive'
                            //                         : 'text-orange-light'}
                            //             >
                            //                 {row.value === 'Active' ? 'check_circle'
                            //                     : row.value === 'Inactive' ? `cancel`
                            //                         : 'Other'}
                            //             </Icon>
                            //             <Icon
                            //                 className='text-orange-light'
                            //                 title={row.original.cx_suspended ? 'Suspended'
                            //                     : ''}
                            //             >
                            //                 {row.original.cx_suspended ? 'info'
                            //                     : ''}
                            //             </Icon>
                            //         </div>
                            //     )
                            // },
                            {
                                Header: "Action",
                                width: 128,
                                className: "justify-start",
                                Cell: row => (

                                    <div className="flex items-center w-8 h-8">
                                        {row.original[1].cx_status === 'Active' ? (
                                            <div className="flex items-center">
                                                <IconButton
                                                    title='Edit'
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        // this.removeContactPersonEdit();
                                                        this.openNewCustomerDialogEdit(row.original[1]);
                                                    }}
                                                >
                                                    <Icon className='text-blue'>mode_edit</Icon>
                                                </IconButton>
                                                <IconButton
                                                    title='Diactivate'
                                                    onClick={(ev) => { ev.stopPropagation(); this.removeCustomerConfirm(row.original[1].cx_id); }}
                                                >
                                                    <Icon className='text-green-light'>
                                                        check_circle
                                                    </Icon>
                                                </IconButton>
                                            </div>
                                        )
                                            : (
                                                <div className="flex items-center">
                                                    {row.original[1].cx_status === 'Active' ? (
                                                        <div className="flex items-center">
                                                            <IconButton
                                                                title='Edit'
                                                                className={classes.smaller}
                                                                onClick={(ev) => {
                                                                    ev.stopPropagation();
                                                                    // this.removeContactPersonEdit();
                                                                    this.openNewCustomerDialogEdit(row.original[1]);
                                                                }}
                                                            >
                                                                <Icon className='text-blue'>mode_edit</Icon>
                                                            </IconButton>
                                                            <IconButton
                                                                title='Diactivate'
                                                                className={classes.smaller}
                                                                onClick={(ev) => { ev.stopPropagation(); this.removeCustomerConfirm(row.original[1].cx_id); }}
                                                            >
                                                                <Icon className='text-red-light'>
                                                                    delete
                                                                </Icon>
                                                            </IconButton>
                                                        </div>
                                                    )
                                                        : (
                                                            <div className="flex items-center">
                                                                <IconButton
                                                                    title='Edit'
                                                                    disabled
                                                                >
                                                                    <Icon>mode_edit</Icon>
                                                                </IconButton>
                                                                <IconButton
                                                                    title='Activate'
                                                                    onClick={(ev) => { ev.stopPropagation(); this.activateCustomerConfirm(row.original[1].cx_id); }}
                                                                >

                                                                    <Icon className='text-red-light'>
                                                                        cancel
                                                                    </Icon>
                                                                </IconButton>
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                    </div>
                                )
                            }
                        ]}
                        defaultPageSize={10}
                        noDataText="No customers found"
                    />
                    <Dialog className={classNames(classes.root, "z-10")} {...customerList.props} open={this.state.openComposeDialog} fullScreen>

                        <AppBar className="flex w-full app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    New Customer
                                </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <Formsy
                            onValidSubmit={this.addCustomer}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            // onInvalidSubmit={this.validateCustomer}
                            ref={(form) => this.form = form}
                            className="flex flex-col justify-center"
                        >
                            <DialogContent className="p-24">

                                <div className={classes.root}>
                                    <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                                        <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                            <Typography className={classes.heading}>Customer Details</Typography>
                                            <Typography className={classes.secondaryHeading}></Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails
                                            className="flex flex-wrap -mx-3 mb-6"
                                        >
                                            <SelectFormsy
                                                className="w-full md:w-1/6 p-8 mt-12"
                                                name="cx_type"
                                                label="Customer Type"
                                                value="Retail"
                                                Required
                                            >
                                                {cx_types.map(option => (
                                                    <MenuItem className="popup-value-size" key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </SelectFormsy>
                                            <TextFieldFormsy
                                                className="w-full md:w-2/5 p-8 mt-12"
                                                type="text"
                                                name="cx_ref"
                                                ref="cx_ref"
                                                label="Reference Number"
                                                autoFocus
                                            />
                                            <div className="w-full md:w-2/5 p-8 mt-12"></div>
                                            <SelectFormsy
                                                className="w-full md:w-1/6 p-8 mt-12"
                                                name="cx_title"
                                                label="Title"
                                                value="Mr"
                                                required
                                            >
                                                {titles.map(option => (
                                                    <MenuItem className="popup-value-size" key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </SelectFormsy>
                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cx_name"
                                                id="cx_name"
                                                ref="cx_name"
                                                label="Display Name"
                                                required
                                            />
                                            {/* <TextField
                                                className="w-full md:w-2/5 p-8 mt-12"
                                                type="text"
                                                name="cx_name_tmp"
                                                id="cx_name_tmp"
                                                ref="cx_name_tmp"
                                                label="Display Name"
                                                required
                                                onChange={(ev) => {
                                                    ev.stopPropagation();
                                                    // this.changeBackground("cx_name");
                                                }}
                                            /> */}
                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cx_company"
                                                id="cx_company"
                                                ref="cx_company"
                                                label="Company Name"
                                                required
                                            />
                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cx_email"
                                                ref="cx_email"
                                                label="Email Address"
                                                required
                                            />
                                            <div className="w-2/5 p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                                <TextFieldFormsy
                                                    className="w-full p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address"
                                                    id="cx_postal_address"
                                                    ref="cx_postal_address"
                                                    label="Postal Address"
                                                    required
                                                />
                                                <TextFieldFormsy

                                                    type="hidden"
                                                    name="cx_postal_address_country"
                                                    ref="cx_postal_address_country"
                                                    value={this.state.cxPostalCountry.value}

                                                />
                                                <Typography variant="caption" className="w-full md:w-1/2 my-8">Country</Typography>
                                                <Select
                                                    className="w-full md:w-1/2"
                                                    name="cx_postal_address_country_tmp"
                                                    placeholder="Search Country"
                                                    value={this.state.cxPostalCountry}
                                                    onChange={this.handlecxPostalCountryChange}
                                                    options={this.state.countries}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_state"
                                                    ref="cx_postal_address_state"
                                                    label="State"

                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_city"
                                                    ref="cx_postal_address_city"
                                                    label="City"

                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_zipcode"
                                                    ref="cx_postal_address_zipcode"
                                                    label="Zipcode"

                                                />
                                            </div>
                                            <div className="w-1/5 p-8 mt-12 justify-center customer-list-move-btn">
                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    onClose={this.handleTooltipClose}
                                                    onOpen={this.handleTooltipOpen}
                                                    open={this.state.open}
                                                    placement="bottom"
                                                    title="Copy Same Address"
                                                >

                                                    <IconButton
                                                        className="w-full pt-8"
                                                        variant="fab"
                                                        color="primary"
                                                        onClick={this.copyPostalAddress}
                                                    >
                                                        <Icon>navigate_next</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            <div className="w-2/5 p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                                <TextFieldFormsy
                                                    className="w-full p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address"
                                                    id="cx_billing_address"
                                                    ref="cx_billing_address"
                                                    label="Billing Address"
                                                    required
                                                />
                                                <TextFieldFormsy
                                                    type="hidden"
                                                    name="cx_billing_address_country"
                                                    ref="cx_billing_address_country"
                                                    value={this.state.cxBillingCountry.value}
                                                />

                                                <Typography variant="caption" className="w-full md:w-1/2 my-8">Country</Typography>
                                                <Select
                                                    className="w-full md:w-1/2"
                                                    name="cx_billing_address_country_tmp"
                                                    placeholder="Search Country"
                                                    value={this.state.cxBillingCountry}
                                                    onChange={this.handlecxBillingCountryChange}
                                                    options={this.state.countries}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_state"
                                                    ref="cx_billing_address_state"
                                                    label="State"
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_city"
                                                    ref="cx_billing_address_city"
                                                    label="City"
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_zipcode"
                                                    ref="cx_billing_address_zipcode"
                                                    label="Zipcode"
                                                />
                                            </div>
                                            {window.env != "IMC" ?
                                                <div>
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/3 p-8 mt-12"
                                                        type="text"
                                                        name="cx_tax"
                                                        label="VAT Number *"
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/3 p-8 mt-12"
                                                        type="text"
                                                        name="cx_svat"
                                                        label="SVAT Number *"
                                                    />
                                                </div>
                                                : ""}
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                                        <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                            <Typography className={classes.heading}>Contact Persons</Typography>
                                            <Typography className={classes.secondaryHeading}> </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails
                                            className="flex flex-wrap -mx-3 mb-6"
                                        >
                                            <SelectFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                name="cp_title"
                                                ref="cp_title"
                                                label="Title"
                                                value="Mr"
                                            >
                                                {titles.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </SelectFormsy>
                                            <TextFieldFormsy
                                                className="w-full md:w-3/5 p-8 mt-12"
                                                type="text"
                                                name="cp_name"
                                                ref="cp_name"
                                                id="cp_name"
                                                label="Contact Person *"
                                            />
                                            {window.env != "IMC" ?
                                                <div>
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_nic_ssn_passport"
                                                        ref="cp_nic_ssn_passport"
                                                        label="NIC/SSN/Passport"
                                                    />
                                                    <div className="w-full p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                                        <TextFieldFormsy
                                                            className="w-full p-8 mt-12"
                                                            type="text"
                                                            name="cp_address"
                                                            ref="cp_address"
                                                            label="Address *"
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="cp_address_country"
                                                            ref="cp_address_country"
                                                            value={this.state.cpPostalCountry.value}
                                                        />
                                                        <Typography variant="caption" className="w-full md:w-1/4 my-8">Country</Typography>
                                                        <Select
                                                            className="w-full md:w-1/4"
                                                            name="cp_address_country_tmp"
                                                            placeholder="Search Country"
                                                            value={this.state.cpPostalCountry}
                                                            onChange={this.handlecpPostalCountryChange}
                                                            options={this.state.countries}
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/4 p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_state"
                                                            ref="cp_address_state"
                                                            label="State"
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/4 p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_city"
                                                            ref="cp_address_city"
                                                            label="City"
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/4 p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_zipcode"
                                                            ref="cp_address_zipcode"
                                                            label="Zipcode"
                                                        />
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cp_mobile"
                                                ref="cp_mobile"
                                                label="Phone(Mobile) *"
                                                validations={{
                                                    minLength: 10,
                                                    isNumeric: true
                                                }}
                                                validationErrors={{
                                                    minLength: 'This is not a valid Phone Number',
                                                    isNumeric: 'This is not a valid Phone Number'
                                                }}
                                            />
                                            {window.env != "IMC" ?
                                                <div>
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_home"
                                                        ref="cp_home"
                                                        label="Phone(Home)"
                                                        validations={{
                                                            minLength: 10,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid Phone Number',
                                                            isNumeric: 'This is not a valid Phone Number'
                                                        }}
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_office"
                                                        ref="cp_office"
                                                        label="Phone(Office)"
                                                        validations={{
                                                            minLength: 10,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid Phone Number',
                                                            isNumeric: 'This is not a valid Phone Number'
                                                        }}
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_fax"
                                                        ref="cp_fax"
                                                        label="Fax"
                                                        validations={{
                                                            minLength: 10,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid Fax Number',
                                                            isNumeric: 'This is not a valid Fax Number'
                                                        }}
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_email"
                                                        ref="cp_email"
                                                        label="Email"
                                                        validations="isEmail"
                                                        validationError="This is not a valid email"
                                                    />
                                                </div> : ""
                                            }
                                            <div className="md:w-4/5 p-8 mt-12"></div>
                                            <Button
                                                className="md:w-1/6 my-12"
                                                variant="raised"
                                                color="secondary"
                                                size="small"
                                                onClick={() => this.pushContactPerson()}
                                            >
                                                Add Person
                                            </Button>
                                            <div className="w-full p-8">
                                                <ReactTable
                                                    className={classNames(classes.root, "-striped -highlight w-full")}

                                                    data={cp_data}
                                                    columns={columns}
                                                    defaultPageSize={5}
                                                    noDataText="No contact persons"
                                                />
                                            </div>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    {window.env != "IMC" ?
                                        <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                                            <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                                <Typography className={classes.heading}>Customer Privileges</Typography>
                                                <Typography className={classes.secondaryHeading}> </Typography>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails
                                                className="flex flex-wrap -mx-3 mb-6"
                                            >
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_credit_limit"
                                                    id="cx_credit_limit"
                                                    ref="cx_credit_limit"
                                                    label="Credit Limit"
                                                    required
                                                    validations={{
                                                        isNumeric: true
                                                    }}
                                                    validationErrors={{
                                                        isNumeric: 'This is not a valid Value'
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">LKR</InputAdornment>,
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_credit_period"
                                                    id="cx_credit_period"
                                                    ref="cx_credit_period"
                                                    label="Credit Period"
                                                    required
                                                    validations={{
                                                        isNumeric: true
                                                    }}
                                                    validationErrors={{
                                                        isNumeric: 'This is not a valid Value'
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">DAYS</InputAdornment>,
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_previlage_discount"
                                                    id="cx_previlage_discount"
                                                    ref="cx_previlage_discount"
                                                    label="Previlage Discount"
                                                    required
                                                    validations={{
                                                        isNumeric: true,
                                                    }}
                                                    validationErrors={{
                                                        isNumeric: 'This is not a valid Value',
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start"></InputAdornment>,
                                                        endAdornment: <InputAdornment position="end"><Typography>%</Typography></InputAdornment>,
                                                    }}
                                                />
                                                <CheckboxFormsy
                                                    className=""
                                                    name="cx_suspended"
                                                    label="Susspended"
                                                />
                                                <CheckboxFormsy
                                                    className=""
                                                    name="cx_active"
                                                    value="true"
                                                    label="Active"
                                                />
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel> : ""}
                                </div>
                            </DialogContent>
                            <DialogActions className="justify-right pl-16">
                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="secondary"
                                    size="small"
                                >
                                    Create
                                </Button>
                                <Button
                                    type="reset"
                                    variant="raised"
                                    color="default"
                                    size="small"
                                >
                                    Reset
                                </Button>
                                <Button
                                    variant="raised"
                                    color="default"
                                    size="small"
                                >
                                    Help
                                </Button>
                                <Button
                                    variant="raised"
                                    color="primary"
                                    size="small"
                                    onClick={this.closeNewCustomerDialog}
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Formsy>
                    </Dialog>

                    <Dialog className={classNames(classes.root, "z-10")} {...customerList.props} open={this.state.openComposeDialogEdit} fullScreen>
                        <AppBar position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    Edit Customer
                                </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialogEdit} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <Formsy
                            onValidSubmit={this.editCustomer}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            ref={(form) => this.form = form}
                            className="flex flex-col justify-center"
                        >
                            <DialogContent className="p-24">

                                <div className={classes.root}>
                                    <ExpansionPanel expanded={expanded === 'panelEdit1'} onChange={this.handleChange('panelEdit1')}>
                                        <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                            <Typography className={classes.heading}>Customer Details</Typography>
                                            <Typography className={classes.secondaryHeading}></Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails
                                            className="flex flex-wrap -mx-3 mb-6"
                                        >
                                            <TextFieldFormsy
                                                type="hidden"
                                                name="cx_id_edit"
                                                ref="cx_id_edit"
                                                value={this.state.editCustomerState.cx_id}
                                            />
                                            <TextFieldFormsy
                                                type="hidden"
                                                name="created_date"
                                                ref="created_date"
                                                value={this.state.editCustomerState.created_date}
                                            />
                                            <SelectFormsy
                                                className="w-full md:w-1/6 p-8 mt-12"
                                                name="cx_type_edit"
                                                label="Customer Type"
                                                value={this.state.editCustomerState.cx_type}
                                                Required
                                            >
                                                {cx_types.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </SelectFormsy>
                                            <TextFieldFormsy
                                                className="w-full md:w-2/5 p-8 mt-12"
                                                type="text"
                                                name="cx_ref_edit"
                                                ref="cx_ref_edit"
                                                label="Reference Number"
                                                value={this.state.editCustomerState.cx_ref}
                                                autoFocus
                                            />
                                            <div className="w-full md:w-2/5 p-8 mt-12"></div>
                                            <SelectFormsy
                                                className="w-full md:w-1/6 p-8 mt-12"
                                                name="cx_title_edit"
                                                label="Title"
                                                value={this.state.editCustomerState.cx_title}
                                                required
                                            >
                                                {titles.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </SelectFormsy>
                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cx_name_edit"
                                                label="Display Name"
                                                value={this.state.editCustomerState.cx_name}
                                                required
                                            />
                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cx_company_edit"
                                                label="Company Name"
                                                value={this.state.editCustomerState.cx_company_name}
                                                required
                                            />
                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cx_email_edit"
                                                ref="cx_email_edit"
                                                label="Email Address"
                                                value={this.state.editCustomerState.cx_email}
                                                required
                                            />
                                            <div className="w-2/5 p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                                <TextFieldFormsy
                                                    className="w-full p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_edit"
                                                    ref="cx_postal_address_edit"
                                                    label="Postal Address"
                                                    value={this.state.editCustomerState.cx_postal_address}
                                                    required
                                                />
                                                <TextFieldFormsy
                                                    type="hidden"
                                                    name="cx_postal_address_country_edit"
                                                    ref="cx_postal_address_country_edit"
                                                    value={this.state.editCustomerState.cx_postal_address_country.value}
                                                />
                                                <Typography variant="caption" className="w-full md:w-1/2 my-8">Country</Typography>
                                                <Select
                                                    className="w-full md:w-1/2"
                                                    name="cx_postal_address_country_edit_tmp"
                                                    placeholder="Search Country"
                                                    value={this.state.editCustomerState.cx_postal_address_country}
                                                    onChange={this.handlecxPostalCountryChangeEdit}
                                                    options={this.state.countries}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_state_edit"
                                                    ref="cx_postal_address_state_edit"
                                                    label="State"
                                                    value={this.state.editCustomerState.cx_postal_address_state}

                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_city_edit"
                                                    ref="cx_postal_address_city_edit"
                                                    label="City"
                                                    value={this.state.editCustomerState.cx_postal_address_city}

                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_postal_address_zipcode_edit"
                                                    ref="cx_postal_address_zipcode_edit"
                                                    label="Zipcode"
                                                    value={this.state.editCustomerState.cx_postal_address_zipcode}

                                                />
                                            </div>
                                            <div className="w-1/5 p-8 mt-12 justify-center">
                                                <IconButton
                                                    className="w-full pt-8"
                                                    variant="fab"
                                                    color="primary"
                                                    onClick={this.copyPostalAddressEdit}
                                                >
                                                    <Icon>navigate_next</Icon>
                                                </IconButton>
                                            </div>
                                            <div className="w-2/5 p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                                <TextFieldFormsy
                                                    className="w-full p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_edit"
                                                    ref="cx_billing_address_edit"
                                                    label="Billing Address"
                                                    value={this.state.editCustomerState.cx_billing_address}
                                                    required
                                                />

                                                <TextFieldFormsy
                                                    type="hidden"
                                                    name="cx_billing_address_country_edit"
                                                    ref="cx_billing_address_country_edit"
                                                    value={this.state.editCustomerState.cx_billing_address_country.value}

                                                />
                                                <Typography variant="caption" className="w-full md:w-1/2 my-8">Country</Typography>
                                                <Select
                                                    className="w-full md:w-1/2"
                                                    name="cx_billing_address_country_edit_tmp"
                                                    placeholder="Search Country"
                                                    value={this.state.editCustomerState.cx_billing_address_country}
                                                    onChange={this.handlecxBillingCountryChangeEdit}
                                                    options={this.state.countries}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_state_edit"
                                                    ref="cx_billing_address_state_edit"
                                                    label="State"
                                                    value={this.state.editCustomerState.cx_billing_address_state}

                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_city_edit"
                                                    ref="cx_billing_address_city_edit"
                                                    label="City"
                                                    value={this.state.editCustomerState.cx_billing_address_city}

                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_billing_address_zipcode_edit"
                                                    ref="cx_billing_address_zipcode_edit"
                                                    label="Zipcode"
                                                    value={this.state.editCustomerState.cx_billing_address_zipcode}

                                                />
                                            </div>
                                            {window.env != "IMC" ?
                                                <div>
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/3 p-8 mt-12"
                                                        type="text"
                                                        name="cx_tax_edit"
                                                        label="VAT Number *"
                                                        value={this.state.editCustomerState.cx_tax}
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/3 p-8 mt-12"
                                                        type="text"
                                                        name="cx_svat_edit"
                                                        label="SVAT Number *"
                                                        value={this.state.editCustomerState.cx_svat}
                                                    />
                                                </div> : ""
                                            }
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panelEdit2'} onChange={this.handleChange('panelEdit2')}>
                                        <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                            <Typography className={classes.heading}>Contact Persons</Typography>
                                            <Typography className={classes.secondaryHeading}> </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails
                                            className="flex flex-wrap -mx-3 mb-6"
                                        >
                                            <SelectFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                name="cp_title_edit"
                                                ref="cp_title_edit"
                                                label="Title"
                                                value="Mr"
                                            >
                                                {titles.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </SelectFormsy>
                                            <TextFieldFormsy
                                                className="w-full md:w-3/5 p-8 mt-12"
                                                type="text"
                                                name="cp_name_edit"
                                                ref="cp_name_edit"
                                                label="Contact Person *"
                                                value={this.state.editCustomerState.cp_name}
                                            />
                                            {window.env != "IMC" ?
                                                <div>
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_nic_ssn_passport_edit"
                                                        ref="cp_nic_ssn_passport_edit"
                                                        label="NIC/SSN/Passport"
                                                        value={this.state.editCustomerState.cp_nic_ssn_passport}
                                                    />

                                                    <div className="w-full p-8 mt-12 border-solid border-1 rounded border-grey bg-grey-lightest">
                                                        <TextFieldFormsy
                                                            className="w-full p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_edit"
                                                            ref="cp_address_edit"
                                                            label="Address *"
                                                            value={this.state.editCustomerState.cp_address}
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="cp_address_country_edit"
                                                            ref="cp_address_country_edit"
                                                            value={this.state.cp_address_country_edit.value}
                                                        />

                                                        <Typography variant="caption" className="w-full md:w-1/4 my-8">Country</Typography>
                                                        <Select
                                                            className="w-full md:w-1/4"
                                                            name="cp_address_country_edit_tmp"
                                                            placeholder="Search Country"
                                                            value={this.state.cp_address_country_edit}
                                                            onChange={this.handlecpPostalCountryChangeEdit}
                                                            options={this.state.countries}
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/4 p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_state_edit"
                                                            ref="cp_address_state_edit"
                                                            label="State"
                                                            value={this.state.editCustomerState.cp_address_state}
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/4 p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_city_edit"
                                                            ref="cp_address_city_edit"
                                                            label="City"
                                                            value={this.state.editCustomerState.cp_address_city}
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/4 p-8 mt-12"
                                                            type="text"
                                                            name="cp_address_zipcode_edit"
                                                            ref="cp_address_zipcode_edit"
                                                            label="Zipcode"
                                                            value={this.state.editCustomerState.cp_address_zipcode}
                                                        />
                                                    </div>
                                                </div> : ""
                                            }

                                            <TextFieldFormsy
                                                className="w-full md:w-1/5 p-8 mt-12"
                                                type="text"
                                                name="cp_mobile_edit"
                                                ref="cp_mobile_edit"
                                                label="Phone(Mobile) *"
                                                value={this.state.editCustomerState.cp_mobile}
                                                validations={{
                                                    minLength: 10,
                                                    isNumeric: true
                                                }}
                                                validationErrors={{
                                                    minLength: 'This is not a valid Phone Number',
                                                    isNumeric: 'This is not a valid Phone Number'
                                                }}
                                            />
                                            {window.env != "IMC" ?
                                                <div>
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_home_edit"
                                                        ref="cp_home_edit"
                                                        label="Phone(Home)"
                                                        value={this.state.editCustomerState.cp_home}
                                                        validations={{
                                                            minLength: 10,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid Phone Number',
                                                            isNumeric: 'This is not a valid Phone Number'
                                                        }}
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_office_edit"
                                                        ref="cp_office_edit"
                                                        label="Phone(Office)"
                                                        required
                                                        value={this.state.editCustomerState.cp_office}
                                                        validations={{
                                                            minLength: 10,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid Phone Number',
                                                            isNumeric: 'This is not a valid Phone Number'
                                                        }}
                                                    />
                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_fax_edit"
                                                        ref="cp_fax_edit"
                                                        label="Fax"
                                                        value={this.state.editCustomerState.cp_fax}
                                                        validations={{
                                                            minLength: 10,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid Fax Number',
                                                            isNumeric: 'This is not a valid Fax Number'
                                                        }}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5 p-8 mt-12"
                                                        type="text"
                                                        name="cp_email_edit"
                                                        ref="cp_email_edit"
                                                        label="Email"
                                                        value={this.state.editCustomerState.cp_email}
                                                        validations="isEmail"
                                                        validationError="This is not a valid email"
                                                    />
                                                </div>
                                                : ""
                                            }
                                            <div className="md:w-4/5 p-8 mt-12"></div>
                                            <Button
                                                className="md:w-1/5 p-8 mt-12"
                                                variant="raised"
                                                color="secondary"
                                                size="small"
                                                onClick={() => this.pushContactPersonEdit()}
                                            >
                                                Add Person
                                            </Button>
                                            <div className="w-full p-8">
                                                <ReactTable
                                                    className={classNames(classes.root, "-striped -highlight w-full")}
                                                    data={cp_data_edit}
                                                    columns={columns}
                                                    defaultPageSize={5}
                                                    noDataText="No contact persons"
                                                />
                                            </div>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    {window.env != "IMC" ?
                                        <ExpansionPanel expanded={expanded === 'panelEdit3'} onChange={this.handleChange('panelEdit3')}>
                                            <ExpansionPanelSummary className="bg-grey-lighter" expandIcon={<ExpandMoreIcon />}>
                                                <Typography className={classes.heading}>Customer Privileges</Typography>
                                                <Typography className={classes.secondaryHeading}> </Typography>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails
                                                className="flex flex-wrap -mx-3 mb-6"
                                            >
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_credit_limit_edit"
                                                    ref="cx_credit_limit_edit"
                                                    label="Credit Limit"
                                                    value={this.state.editCustomerState.cx_credit_limit}
                                                    validations={{
                                                        isNumeric: true
                                                    }}
                                                    validationErrors={{
                                                        isNumeric: 'This is not a valid Value'
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">LKR</InputAdornment>,
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_credit_period_edit"
                                                    ref="cx_credit_period_edit"
                                                    label="Credit Period"
                                                    value={this.state.editCustomerState.cx_credit_period}
                                                    validations={{
                                                        isNumeric: true
                                                    }}
                                                    validationErrors={{
                                                        isNumeric: 'This is not a valid Value'
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">DAYS</InputAdornment>,
                                                    }}
                                                />
                                                <TextFieldFormsy
                                                    className="w-full md:w-1/3 p-8 mt-12"
                                                    type="text"
                                                    name="cx_previlage_discount_edit"
                                                    ref="cx_previlage_discount_edit"
                                                    label="Previlage Discount"
                                                    value={this.state.editCustomerState.cx_previlage_discount}
                                                    validations={{
                                                        isNumeric: true
                                                    }}
                                                    validationErrors={{
                                                        isNumeric: 'This is not a valid Value'
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start"></InputAdornment>,
                                                        endAdornment: <InputAdornment position="end"><Typography>%</Typography></InputAdornment>,
                                                    }}
                                                />
                                                <CheckboxFormsy
                                                    className=""
                                                    name="cx_suspended_edit"
                                                    label="Susspended"
                                                    value={this.state.editCustomerState.cx_suspended}
                                                    disabled
                                                />
                                                <CheckboxFormsy
                                                    className=""
                                                    name="cx_active_edit"
                                                    label="Active"
                                                    value={this.state.editCustomerState.cx_active}
                                                    disabled
                                                />
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                        : ""
                                    }
                                </div>
                            </DialogContent>
                            <DialogActions className="justify-right pl-16">
                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="secondary"
                                    size="small"
                                >
                                    Update
                                </Button>
                                <Button
                                    variant="raised"
                                    color="primary"
                                    size="small"
                                    onClick={this.closeNewCustomerDialogEdit}
                                >
                                    Close
                                </Button>
                                <Button
                                    variant="raised"
                                    color="default"
                                    size="small"
                                >
                                    Help
                                </Button>
                            </DialogActions>
                        </Formsy>
                    </Dialog>

                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        this.getCustomerList();
        this.loadAllCountries();

        //==================================================================================

        var titles = [];

        axios.get(window.systemServer + '/system/loadTitle')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL") {
                    if (response.data.result) {
                        for (let i = 0; i < response.data.result.length; i++) {

                            titles.push({
                                value: response.data.result[i].title,
                                label: response.data.result[i].title
                            });
                        }
                    }
                }
                else
                    for (let i = 0; i < response.data.length; i++) {

                        titles.push({
                            value: response.data[i].title,
                            label: response.data[i].title
                        });
                    }
                this.setState({ titles: titles });
            });

        //==================================================================================

        var cx_types = [];

        axios.get(window.systemServer + '/system/loadCustomerTypes')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL") {
                    if (response.data.result) {
                        for (let i = 0; i < response.data.result.length; i++) {
                            cx_types.push({
                                value: response.data.result[i].customer_type,
                                label: response.data.result[i].customer_type
                            });
                        }
                    }
                } else
                    for (let i = 0; i < response.data.length; i++) {

                        cx_types.push({
                            value: response.data[i].customer_type,
                            label: response.data[i].customer_type
                        });
                    }
                this.setState({ cx_types: cx_types });
            });
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCustomers: Actions.getCustomers,
        setSearchText: Actions.setSearchText
    }, dispatch);
}

function mapStateToProps() {
    return {
        contacts: [],
        selectedContactIds: [],
        searchText: [],
        user: []
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(withAlert(customerList))));



// WEBPACK FOOTER //
// ./src/main/content/crm/customerList/customerList.js